import React, { Component } from "react"
import { translate } from "react-translate"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import {
  Segment,
  Grid,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Item
} from "semantic-ui-react"
import "./Home.css"
import BandeauNoir from "../Entete/BandeauNoir"
import BouttonEntete from "../Entete/BouttonEntete"
import RechercheFiltre from "../Entete/RechercheFiltre"
import FiltreDevis from "../Entete/FiltreDevis"
import EnteteBody from "./BodyDevisEtFactures/EnteteBody"
import BodyDevisFactures from "./BodyDevisEtFactures/BodyDevisFactures"
import { fileText2 } from "react-icons-kit/icomoon/fileText2"
import { coinEuro } from "react-icons-kit/icomoon/coinEuro"
import _ from "lodash"

import DevisFactureService from "./DevisFactureService"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedDevisFacturesComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      rawData: undefined,
      filters: ["devis", "facture"]
    }
    if (this.props.location && this.props.location.state) {
      this.state.searchValue = this.props.location.state.prefill
    }
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleFilters = this.handleFilters.bind(this)
    this.handleRowDropdownChange = this.handleRowDropdownChange.bind(this)
  }

  handleFilters(btnName) {
    var copy = this.state.filters
    var idxOfFilter = copy.indexOf(btnName)
    if (idxOfFilter > -1) {
      copy.splice(idxOfFilter, 1)
    } else {
      copy.push(btnName)
    }
    this.setState({
      filters: copy
    })
  }

  handleDropdownChange = (e, val) => {
    var tabVal = val.value
    this.setState({
      tabVal
    })
  }

  handleRowDropdownChange = (id, e, val) => {
    var rowVal = val.value
    var rowIdx = _.findIndex(this.state.rawData, x => x.reference == id)
    var rawDataCopy = this.state.rawData

    rawDataCopy[rowIdx].statut = rowVal

    this.setState({
      rawData: rawDataCopy
    })
  }

  componentWillMount() {
    DevisFactureService.fetchData(this.props.app.token)
      .then(data => {
        console.log("Aggregation data : ", data)
        this.setState({ rawData: data })
        console.log("wazza : ", this.state.rawData)
      })
      .catch(err => {
        alert(err)
      })
  }

  handleSaveNewDevis(newDevis) {
    // creation et transformation des propriétés vers le BACK
    let invoiceData = {
      label: newDevis.name,
      fkuiduser: newDevis.nameClient,
      tree: newDevis.adresse,

      //date: jour + "/" + mois + "/" + annee
      statut: 0
    }
    console.log("aaaaa", invoiceData)
    var now = new Date()
    var annee = now.getFullYear()
    var mois = ("0" + (now.getMonth() + 1)).slice(-2)
    var jour = ("0" + now.getDate()).slice(-2)
    //création et transformation des propriétés vers le FRONT
    var newRow = {
      // type: newDevis.toggle,
      reference: newDevis.name,
      name: newDevis.nameClient,
      adress: newDevis.adresse
      // price: newDevis.price,
      //date: jour + "/" + mois + "/" + annee
      // statut: 1
    }
    DevisFactureService.createInvoices(
      this.props.app.token,
      newRow,
      invoiceData
    ).then(res => {
      var tabCopy = this.state.rawData
      tabCopy.push(newRow)
      this.setState({
        rawData: tabCopy
      })
    })
  }
  handleSearchChange(e, data) {
    var searchValue = data.value
    this.setState({
      searchValue
    })
  }

  render() {
    let { t } = this.props
    this.state.newDevis

    return (
      <Segment id="main">
        <BandeauNoir icon={fileText2} category={t("title_bandeau_component")}>
          <BouttonEntete
            text={t("label_button_devis")}
            style="bouttonEntete1"
            icon={fileText2}
          />
          <BouttonEntete
            text={t("label_button_facture")}
            style="bouttonEntete2"
            icon={coinEuro}
          />
        </BandeauNoir>
        <RechercheFiltre
          prestations={t("placeholder_search_bar")}
          // callback de la fonction handleSearchChange
          onSearchChange={this.handleSearchChange}
          searchValue={this.state.searchValue}
        >
          <FiltreDevis
            filter={this.handleFilters}
            activeFilters={this.state.filters}
            handleDropdownChange={this.handleDropdownChange}
          />
        </RechercheFiltre>
        <EnteteBody
          dateEnteteBody="Novembre 2017 :"
          newDevis={data => this.handleSaveNewDevis(data)}
        />
        <BodyDevisFactures
          handleRowDropdownChange={this.handleRowDropdownChange}
          data={DevisFactureService.getDisplayedData(
            this.state.rawData,
            this.state.filters,
            this.state.searchValue,
            this.state.tabVal
          )}
        />
      </Segment>
    )
  }
}

const DevisFacturesComponent = connect(mapStateToProps)(
  ConnectedDevisFacturesComponent
)
export default translate("ProDevisFactureHome")(DevisFacturesComponent)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/Home.jsx